import type { ReactNode } from 'react'

import { cn } from '../utilitarios/cn'

export type TomAlerta = 'info' | 'sucesso' | 'atencao' | 'perigo'

const TONS: Record<TomAlerta, { caixa: string; icone: string }> = {
  info: { caixa: 'bg-info-suave border-info/25 text-conteudo', icone: 'text-info' },
  sucesso: { caixa: 'bg-sucesso-suave border-sucesso/25 text-conteudo', icone: 'text-sucesso' },
  atencao: { caixa: 'bg-atencao-suave border-atencao/30 text-conteudo', icone: 'text-atencao' },
  perigo: { caixa: 'bg-perigo-suave border-perigo/30 text-conteudo', icone: 'text-perigo' },
}

const CAMINHOS: Record<TomAlerta, string> = {
  info: 'M12 8.5h.01M11 12h1v4h1M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z',
  sucesso: 'm8 12.5 2.6 2.6L16.5 9.2M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z',
  atencao: 'M12 9v4m0 3h.01M10.3 4.9 2.6 18.2A1.9 1.9 0 0 0 4.3 21h15.4a1.9 1.9 0 0 0 1.7-2.8L13.7 4.9a1.9 1.9 0 0 0-3.4 0Z',
  perigo: 'M12 8v5m0 3.5h.01M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z',
}

export interface PropriedadesAlerta {
  tom?: TomAlerta
  titulo?: ReactNode
  children?: ReactNode
  acoes?: ReactNode
  className?: string
}

/**
 * Aviso no fluxo da página. É onde entram as mensagens de erro de domínio da API
 * (`LEAD_TRANSICAO_INVALIDA`, `CLIENTE_COM_ATENDIMENTO_EM_ANDAMENTO`): o código é
 * o contrato, a mensagem já vem em pt-BR do servidor (§14), e a tela mostra o
 * texto recebido em vez de reescrever a regra.
 */
export function Alerta({ tom = 'info', titulo, children, acoes, className }: PropriedadesAlerta) {
  const tons = TONS[tom]
  return (
    <div
      role={tom === 'perigo' ? 'alert' : 'status'}
      className={cn('flex gap-3 rounded-md border p-3.5 text-sm', tons.caixa, className)}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 24 24"
        className={cn('mt-0.5 h-5 w-5 shrink-0', tons.icone)}
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d={CAMINHOS[tom]} />
      </svg>
      <div className="min-w-0 flex-1">
        {titulo ? <p className="font-semibold">{titulo}</p> : null}
        {children ? <div className={cn(titulo && 'mt-1', 'text-conteudo-suave')}>{children}</div> : null}
        {acoes ? <div className="mt-3 flex flex-wrap gap-2">{acoes}</div> : null}
      </div>
    </div>
  )
}
